import { isEmbedded } from '../../public/lib/PageHelpers.js';
import PoweredBy from '~/public/components/PoweredBy';
import React from 'react';

const FormBackgroundContainer = ({ styles, className, children }) => {
    const fullPageImage = !!styles?.fullPageImage && styles?.headerImage;
    const fullPageColor = !!styles?.fullPageImage && styles?.headerColor;
    const logo = !styles?.logoDisabled && styles?.logo;

    return (
        <div
            className={`${!isEmbedded() ? 'bg-gray-100' : ''} ${fullPageImage || fullPageColor ? 'p-4' : ''} ${className}`}
            style={{
                backgroundImage: fullPageImage ? `url(${fullPageImage})` : null,
                backgroundColor:
                    !isEmbedded() && fullPageColor ? fullPageColor : '',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'repeat',
            }}
        >
            {children}
        </div>
    );
};

export default FormBackgroundContainer;
